import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse } from '@fortawesome/pro-solid-svg-icons'

import { Box, SectionDivider, Text } from '@domain-group/suit-theme'

import usePublicationBookingItems from '@hooks/usePublicationBookingItems'
import useSelector from '@hooks/useSelector'

interface CampaignAddressesProps {
  publicationBookingItemsPayload: ReturnType<typeof usePublicationBookingItems>,
}

const CampaignAddresses = (props: CampaignAddressesProps) => {
  const { publicationBookingItemsPayload } = props
  const { filteredPublicationBookingItems, filteredPublicationBookingItemsCount } = publicationBookingItemsPayload

  const campaigns = useSelector(reduxState => reduxState.entities.campaigns)

  const dividerText = filteredPublicationBookingItemsCount === 1 ? 'CAMPAIGN ADDRESS' : 'CAMPAIGN ADDRESSESS'
  return (
    <>
      <SectionDivider boxProps={{ marginBottom: 'large' }}>{dividerText}</SectionDivider>

      {Object.values(filteredPublicationBookingItems).map((bookingItem) => {
        // @ts-expect-error TS2538
        const campaign = campaigns[bookingItem.campaign_id] || {}

        return (
          <Box color="bodyFontLightColor" fontSize="xsmall" alignItems="center" marginBottom="large">
            <FontAwesomeIcon icon={faHouse} />

            <Text color="bodyFontColor" key={bookingItem.id} fontSize="small" marginLeft="medium">
              {`${campaign.address}, ${campaign.suburb_name}, ${campaign.state_name} ${campaign.post_code}`}
            </Text>
          </Box>
        )
      })}
    </>
  )
}

export default CampaignAddresses
